const live_url = window.location.href;
const formNewsletter = document.querySelector('form.newsletter-form');
const result = live_url.includes('form_type=customer');
const input = document.querySelector('[newsletter-email-input]');
if (input && formNewsletter) {
    const already_subscribed_text = input.getAttribute('data-already-subscribed');
    const input_val = input.value.length;
    if (result && input_val !== 0) {
        const add_el = document.createElement("h3");
        add_el.innerText = already_subscribed_text;
        formNewsletter.appendChild(add_el);
        add_el.classList.add('newsletter_already_subscribe', 'newsletter-form__message', 'form__message');
    }
}